<script setup>
import { computed, useAttrs } from 'vue';
import YouTubeEmbed from './YouTubeEmbed.vue';
import FacebookVideoEmbed from './FacebookVideoEmbed.vue';

defineOptions({ inheritAttrs: false });

const props = defineProps({
  network: {
    type: String,
    required: true,
  },
});

const attrs = useAttrs();
const component = computed(
  () => ({
    youtube: YouTubeEmbed,
    facebook: FacebookVideoEmbed,
  }[props.network] || null),
);
</script>

<template>
  <component
    :is="component"
    v-bind="attrs"
  />
</template>
